<template>
  <div class="mt-10 mb-10 clearfix">
    <div class="col-sm-6">
      <div class="box-list-item border-bottom size-18">
        Total<sup>[3]</sup> <span class="pull-right weight-mid">{{ total | brlPrice }}</span>
      </div>
      <article
        v-for="(item, index) in items"
        :key="`checkout-car-item-${index}`"
        :class="{ 'border-bottom': index !== (items.length-1) }"
        class="box-list-item clearfix">
        <div class="col-xs-6 col-sm-9 padding-off">
          <h2 class="size-16 weight-bold margin-off">
            {{ item.vehicle.description }}
          </h2>
          <!-- Hotel Detail -->
          <car-detail :item="item"></car-detail>
          <!-- // Hotel Detail -->
        </div>
        <div class="col-xs-6 col-sm-3 padding-off">
          <p class="text-right mt-10">
            {{ item.total | brlPrice }}
          </p>
        </div>
      </article>
    </div>
    <div class="col-sm-6">
      <template v-if="creditCardByProduct">
        <div class="col-sm-10">
          <select-creditcard
            :validation="validation"
            :creditcards="cards"
            name="creditcard_car"
            @handleCreditcard="handleCreditcard"></select-creditcard>
        </div>
        <div class="col-sm-12 mt-10">
          <a
            v-if="creditCardByProduct"
            @click.prevent="$emit('handleParentAction', 'card-register')"
            href="#"
            class="btn-link size-14 weight-normal mt-20">+Adicionar Novo Cartão</a>
        </div>
      </template>
      <p class="size-11 weight-lighter color-gray-light-mid"><sup>[3]</sup> Pagamento somente com cartão de crédito na retirada do veículo</p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CarDetail from '@/components/car/CarDetail'
import SelectCreditcard from '@/components/fields/SelectCreditcard'

export default {
  components: {
    CarDetail,
    SelectCreditcard
  },
  props: [
    'order',
    'items',
    'validation',
    'creditcards',
    'creditCardByProduct'
  ],
  computed: {
    ...mapGetters('reserve', ['totalByOrder']),
    total () {
      return this.totalByOrder('cars')
    },
    cards () {
      if (this.creditcards.length === 0) return []
      return this.creditcards.filter(card => !card.corporate_virtual_hotel && !card.corporate_virtual_flight)
    }
  },
  methods: {
    handleCreditcard (target) {
      this.$emit('handleCreditcard', target)
    }
  }
}
</script>
